import { Box, HStack, Skeleton, Flex } from '@chakra-ui/react';

/**
 * PageSkeleton - Used for the initial app/session loading state
 * Shows the general page structure while session is being validated
 */
const PageSkeleton = () => {
    return (
        <Box
            w="100%"
            maxW="1600px"
            px={4}
            pt={3}
            pb={2}
            h="calc(100dvh - var(--partbay-topbar))"
            display="flex"
            flexDirection="column"
        >
            {/* Header Row */}
            <HStack mb={4} justify="space-between">
                <Skeleton height="28px" width="200px" borderRadius="md" />
                <HStack spacing={2}>
                    <Skeleton height="36px" width="240px" borderRadius="md" />
                    <Skeleton height="36px" width="180px" borderRadius="md" />
                    <Skeleton height="36px" width="36px" borderRadius="md" />
                    <Skeleton height="36px" width="36px" borderRadius="md" />
                </HStack>
            </HStack>

            {/* Main Content Area */}
            <Box
                flex={1}
                border="1px solid"
                borderColor="gray.200"
                borderRadius="lg"
                overflow="hidden"
            >
                {/* Table Header */}
                <Flex bg="gray.50" p={3} borderBottom="1px solid" borderColor="gray.200">
                    {Array(7).fill(0).map((_, i) => (
                        <Box key={i} flex={i === 0 ? 2 : 1} px={2}>
                            <Skeleton height="12px" width="60px" borderRadius="md" />
                        </Box>
                    ))}
                </Flex>

                {/* Table Rows */}
                {Array(12).fill(0).map((_, rowIdx) => (
                    <Flex 
                        key={rowIdx} 
                        p={3} 
                        borderBottom="1px solid" 
                        borderColor="gray.100"
                        align="center"
                    >
                        {Array(7).fill(0).map((_, colIdx) => (
                            <Box key={colIdx} flex={colIdx === 0 ? 2 : 1} px={2}>
                                <Skeleton 
                                    height="16px" 
                                    width={colIdx === 0 ? "80%" : colIdx === 6 ? "60px" : "70%"} 
                                    borderRadius="md"
                                />
                            </Box>
                        ))}
                    </Flex>
                ))}
            </Box>

            {/* Pagination */}
            <Flex justify="center" mt={4}>
                <HStack spacing={2}>
                    <Skeleton height="32px" width="32px" borderRadius="md" />
                    <Skeleton height="32px" width="32px" borderRadius="md" />
                    <Skeleton height="32px" width="32px" borderRadius="md" />
                </HStack>
            </Flex>
        </Box>
    );
};

export default PageSkeleton;
